<template>
  <div class="w-100">
    <v-card elevation="0" class="w-100">
      <v-col cols="12" md="6">
        <v-card-title> کاربر مدنظر خود را جستجو کنید </v-card-title>

        <commercial-user-picke
          v-model="userpicker.users"
          :api-url="userpicker.apiUrl"
          :errors="userpicker.apiUrl"
          @confirm="onConfirmSelection"
        />
      </v-col>
    </v-card>
    <custom-tabs v-model="tabs" :tab-items="tabis" grow>
      <template v-slot:staticItems>
        <v-tab-item class="pa-2">
          <commercial-list-item-four
            :info="value"
            :qrland="qrland"
            :admin="admin"
          />
        </v-tab-item>
        <v-tab-item class="pa-2">
          <commercial-list-item-five
            :info="value"
            :qrland="qrland"
            :admin="admin"
          />
        </v-tab-item>
      </template>
    </custom-tabs>
  </div>
</template>

<script>
import commercialListItemFive from "../../commercialListCo/commercialListItemFive.vue";
import commercialListItemFour from "../../commercialListCo/commercialListItemFour.vue";
import commercialUserPicke from "./commercialUserPicker.vue";
export default {
  props: {
    qrland: [Number, String],
    value: [Object, Array, null],
    admin: [Boolean, null],
  },
  name: "commercialAdminManager",
  components: {
    commercialListItemFive,
    commercialListItemFour,
    commercialUserPicke,
  },
  data() {
    return {
      tabs: null,
      tabis: [
        {
          text: "مدیریت نمایش",
          value: "",
          icon: "view-grid-plus-outline",
        },
        {
          text: "مدیریت اجاره",
          value: "",
          icon: "cash-sync",
        },
      ],
      userpicker: {
        users: [],
        apiUrl: "/api/user",
        errors: [],
      },
    };
  },

  methods: {
    onConfirmSelection() {
      console.log("ok");
    },
  },
};
</script>

<style></style>
